<script setup lang="ts">
// import { $t } from "@/i18n";
import { useDefaultStore } from "@/store";

const store = useDefaultStore();

useHead({
  title: `${store.SITE_NAME}`,
  meta: [
    {
      name: "title",
      content: `${store.SITE_NAME}`,
    },
    {
      name: "description",
      content:
        "ICM Elektro je savremena firma specijalizovana za izvođenje elektroinstalacionih radova, ugradnju solarnih sistema, sigurnosnih kamera, kao i kompletnu izgradnju objekata po sistemu “ključ u ruke”.",
    },
    { name: "robots", content: "index, follow" },
    {
      property: "og:title",
      content: `${store.SITE_NAME}`,
    },
    {
      property: "og:description",
      content:
        "ICM Elektro je savremena firma specijalizovana za izvođenje elektroinstalacionih radova, ugradnju solarnih sistema, sigurnosnih kamera, kao i kompletnu izgradnju objekata po sistemu “ključ u ruke”.",
    },
    { property: "og:site_name", content: store.SITE_NAME },
  ],
});
</script>

<template>
  <main class="bg-text-dark pt-18 md:pt-38">
    <div class="flex flex-col">
      <h1 class="sr-only hidden">{{ store.SITE_NAME }}</h1>
      <home-hero :key="store.heroSectionKey"></home-hero>
      <about-us-section></about-us-section>
      <services-section></services-section>
      <contact-section></contact-section>
    </div>
  </main>
</template>
